import React, { Fragment } from 'react';
import { string } from 'prop-types';
import { sansSerif, grayDarker } from 'styles/css-constants';

function ImageCaption({ credit, caption }) {
  const cleanCaption = caption && caption.replace(credit, '').trim();

  return (
    <Fragment>
      <figcaption className="ImageCaption">
        {credit && (
          <div
            className="ImageCaption__credit"
            dangerouslySetInnerHTML={{ __html: credit }}
          />
        )}
        {!!cleanCaption && (
          <span
            className="ImageCaption__caption"
            dangerouslySetInnerHTML={{
              __html: cleanCaption
            }}
          />
        )}
      </figcaption>
      <style jsx>{`
        .ImageCaption :global(a) {
          color: ${grayDarker};
          border-bottom: 1px solid ${grayDarker};
          text-decoration: none;
        }

        .ImageCaption {
          color: inherit;
        }

        .ImageCaption__caption {
          padding-top: 0.5rem;
          display: block;
          color: ${grayDarker};
          font-family: ${sansSerif};
          font-size: var(--fontScaleNeg1);
          line-height: 1.4;
        }

        .ImageCaption__credit {
          font-family: ${sansSerif};
          font-size: var(--fontScaleNeg2);
          color: ${grayDarker};
        }
      `}</style>
    </Fragment>
  );
}

ImageCaption.propTypes = {
  caption: string,
  credit: string
};

ImageCaption.defaultProps = {
  caption: undefined,
  credit: undefined
};

export default ImageCaption;
